import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { EmployerStore } from '../../../../store/employer-store';
import { JobSkill } from '../../../../../shared/models/job-skill';
import { Observable, Subscription } from 'rxjs';

@Component({
  selector: 'job-skills-form',
  templateUrl: './skills-form.component.html',
  styleUrls: ['./skills-form.component.scss']
})
export class JobSkillsFormComponent implements OnInit, OnDestroy {
  @Input() collapse_skills: boolean;
  @Input() jobSkills: Observable<JobSkill[]>;

  private subscriptions: Subscription[] = [];
  form: FormGroup;

  constructor(private formBuilder: FormBuilder, public dashboardState: EmployerStore) {
  }

  get skills() { return this.form.get('skills') as FormArray; }

  ngOnInit() {

    this.form = this.formBuilder.group(
      {
        skills: new FormArray([this.formBuilder.group(
          {
            title: [''],
            level: ['']
          }
        )])
      }
    );

    if(this.jobSkills) {
      this.subscriptions.push(
        this.jobSkills.subscribe(skills => {
          skills.forEach((skill, index) => {
            this.skills.insert(index,this.formBuilder.group({
              title: [skill.title],
              level: [skill.level]
            }));
          });
        }));
    }
  }

  ngOnDestroy(): void {
    this.dashboardState.clearSkills();
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  public add(): void {
    if (!this.form.valid) {
      return;
    }

    this.dashboardState.addSkill(JobSkill.parseForm(this.skills.controls[this.skills.controls.length - 1] as FormGroup));

    this.skills.push(this.formBuilder.group({
      title: [''],
      level: ['']
    }));
  }

  public remove(index: number): void {
    if (index == 0) {
      return;
    }

    this.skills.removeAt(index);
    this.dashboardState.removeSkill(index);
  }

  canAdd(index: number): boolean {
    return this.dashboardState.getSkills().length === index;
  }
}
